// Honest message for an /api/parse non-200, keyed on the failure code (which rides in the response body's `error`
// field for every parse failure — incl. the 503 envelope from the server's userError(), where `error` is the code).
// Each code gets advice that matches its ACTUAL cause; the generic fallback is the genuine retry case only, NOT a
// catch-all that tells users to "paste a cleaner copy" when the CV is fine (it was too long / timed out / the
// reader was busy).

const SECTIONS_ADVICE = ' — try importing it in sections, or paste one section at a time.';

const GENERIC = "We couldn't read that CV into entries — go back and try again, or paste a cleaner copy.";

const MESSAGES: Record<string, string> = {
  // 422 — output truncated even at the 16k ceiling: a genuinely huge CV (retrying won't help).
  parse_too_long: 'This CV is very long' + SECTIONS_ADVICE,
  // 413 — raw text over the 60k char cap (sibling of 422 — same import-in-sections advice, different trigger).
  cv_too_large: 'This CV is too large to read at once' + SECTIONS_ADVICE,
  // 502 timeout — parse exceeded the time budget; a smaller chunk reads faster.
  parse_timeout: 'That took too long to read — try importing one section at a time.',
  // 503 — the LLM tier is at capacity / paused: a service state, the CV is fine. Retry later, do NOT re-edit the CV.
  free_llm_at_capacity: 'The reader is busy right now — please try again in a few minutes.',
};

/** Map an /api/parse failure code to an honest, actionable message. Unknown / parse_failed / network → generic retry. */
export function parseErrorMessage(code: string | undefined | null): string {
  return (code && MESSAGES[code]) || GENERIC;
}
